import { SiteLayout, PageHero } from "@/components/site/SiteLayout";
import { DemoForm } from "@/components/site/DemoForm";

const EXPECT = [
  ["30 minutes, confidential", "A conversation about your product, markets and current strategy — under confidentiality from the first word."],
  ["A live walkthrough", "See a readiness analysis on scenarios relevant to your portfolio — scores, gaps, sequencing and the reasoning behind them."],
  ["A straight answer", "If an engagement isn't the right fit for your stage, we'll say so — and tell you when it will be."],
];

export default function RequestDemo() {
  return (
    <SiteLayout>
      <PageHero overline="Request a Demo" title="See your product's readiness — live."
        lede="A 30-minute walkthrough with our market access team, using scenarios relevant to your portfolio." />
      <section className="bg-slate-950 py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5 space-y-6">
            {EXPECT.map(([title, text]) => (
              <div key={title} className="border-l-2 border-emerald-500 pl-5">
                <p className="font-heading font-bold text-white text-sm">{title}</p>
                <p className="text-sm text-slate-400 leading-relaxed mt-1.5">{text}</p>
              </div>
            ))}
            <p className="text-[11px] text-slate-500 leading-relaxed pt-2">Prefer email? Write to us via the form and mention your preferred times — we respond within one business day.</p>
          </div>
          <div className="lg:col-span-7"><DemoForm /></div>
        </div>
      </section>
    </SiteLayout>
  );
}
